import { css } from '@emotion/react';
import { Container, styled } from '@mui/joy';

export const ErrorRoot = styled(Container)(
  ({ theme }) => css`
    min-height: 100vh;
    padding-top: ${theme.spacing(8)};
    padding-bottom: ${theme.spacing(8)};
    display: flex;
    align-items: center;
    justify-content: stretch;
  `,
);
